import {FC} from 'react';
import Link from 'next/link';

import Logos from '../../../Logos';

import {LayoutFooterProps} from './types';

import styles from '../../styles.module.scss';

const LayoutFooter: FC<LayoutFooterProps> = ({
  show,
  currentYear,
  isNerdwallet,
}) => {
  if (!show) return null;

  return (
    <footer className={styles.layout__footer}>
      <section className={styles.layout__footer_copyright}>
        <Logos />
        <span>© {currentYear} Zoe Financial, Inc. | All rights reserved</span>
        {isNerdwallet && (
          <span>
            © 2017-{currentYear} and TM, NerdWallet, Inc. All Rights Reserved.
          </span>
        )}
      </section>
      <section className={styles.layout__footer_nav}>
        <Link
          href="https://findanadvisor.com/global-disclosure"
          target="_blank"
          rel="noreferrer">
          Disclosures
        </Link>
        <Link
          href="https://findanadvisor.com/privacy-policy"
          target="_blank"
          rel="noreferrer">
          Privacy Policy
        </Link>
        <Link
          href="https://findanadvisor.com/contact"
          target="_blank"
          rel="noreferrer">
          Contact Us
        </Link>
        <Link
          href="https://findanadvisor.com/terms-of-use"
          target="_blank"
          rel="noreferrer">
          Terms of Use
        </Link>
      </section>
    </footer>
  );
};

export default LayoutFooter;
